import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { PatientRefRelationModel, SimpleConfigModel } from '../models/SimpleConfigModel';




@Injectable({
    providedIn: 'root'
})

export class SimpleConfigService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/SimpleConfig';

    



    getAllData() {
        return this.http.get<SimpleConfigModel>(this.baseurl + this.pathName + '/PatientGenderWithTitle');
    }

    getPatientRefRelation(){
        return this.http.get<PatientRefRelationModel[]>(this.baseurl + this.pathName + '/PatientRefRelation');

    }
    

}